<template>
    <button
        @click="accordionOpen = !accordionOpen"
        :class="[
            {
                'open': accordionOpen,
            },
            'accordion-item d-block'
        ]"
    >
        <h3 class="accordion-title">
            {{ title }}
            <icon
                :icon="accordionOpen ? 'min' : 'plus'"
            />
        </h3>
        <div
            class="accordion-inner mt-4"
        >
            <slot />
        </div>
    </button>
</template>

<script>
    import Icon from '@/components/icon';

    export default {
        name: 'Accordion',
        components: {
            Icon,
        },
        data() {
            return {
                accordionOpen: false,
            };
        },
        props: {
            title: {
                required: true,
                type: String,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .accordion {
        &-item {
            width: 100%;
            padding: 20px 0;
            cursor: pointer;
            border-bottom: 1px solid $wild-sand;
            transition: border-color 0.3s;

            &:hover {
                border-color: $shakespear;
            }

            &.open {
                border-color: $shakespear;
            }
        }

        &-inner {
            display: none;
            font-size: 14px;

            .open & {
                display: block;
            }
        }

        &-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0;
            font-family: $font-body;
            font-size: 14px;
            font-weight: 700;
            line-height: 12px;
            color: $cod-gray;
            text-transform: uppercase;

            .icon {
                font-size: 18px;
                color: $pale-oyster;

                .open & {
                    transform: scale(-1);
                }
            }
        }

        dl {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }

        dt {
            width: 100%;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 700;
            color: $cod-gray;

            &:first-child {
                padding: 0;
            }
        }

        dd {
            display: flex;
            width: 100%;
            padding-top: 8px;
            margin: 0;
            font-size: 14px;

            &:nth-child(2) {
                padding: 0;
            }
        }
    }
</style>
